import { Entry, Locale } from 'contentful';
import { TypeTrainSkeleton } from '@/@types/generated/contentful';
import MultiLocaleService from './base/MultiLocaleService';
import ITrain from '../types/base/ITrain';

export default class TrainService extends MultiLocaleService {
	public async getTrains(): Promise<Record<string, ITrain[]>> {
		const trains = await this.deliveryClient.withAllLocales.getEntries<TypeTrainSkeleton>({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'train',
			include: 10
		});

		const trainsByLocaleCode: Record<string, ITrain[]> = {};

		this.locales.forEach((locale: Locale): void => {
			trainsByLocaleCode[locale.code] = trains.items.map(
				(trainEntry: Entry<any>): ITrain => {
					const train: ITrain = {
						...this.mapToSingleLocaleObject(trainEntry.fields, locale),
						id: trainEntry.sys.id,
						image:
							trainEntry.fields.image && (trainEntry.fields.image as any).de.fields
								? (trainEntry.fields.image as any).de.fields.asset.de
								: undefined
					};

					return train;
				}
			);
		});

		return trainsByLocaleCode;
	}
}
